const Square = ({ 
  square, 
  piece, 
  isLight, 
  isSelected, 
  isLegalMove, 
  isLastMove, 
  isCheck,
  onClick 
}) => {
  const getPieceUnicode = (piece) => {
    if (!piece) return '';
    
    const pieces = {
      'k': piece.color === 'w' ? '♔' : '♚',
      'q': piece.color === 'w' ? '♕' : '♛',
      'r': piece.color === 'w' ? '♖' : '♜',
      'b': piece.color === 'w' ? '♗' : '♝',
      'n': piece.color === 'w' ? '♘' : '♞',
      'p': piece.color === 'w' ? '♙' : '♟'
    };
    
    return pieces[piece.type] || '';
  };

  return (
    <button
      className={`
        relative w-full aspect-square
        transition-all duration-150
        border border-border-heavy dark:border-dark-border-heavy
        ${isLight ? 'bg-[#EBECD0] dark:bg-[#B8B8B8]' : 'bg-[#739552] dark:bg-[#5A7A42]'}
        ${isSelected ? 'bg-[#BACA2B] dark:bg-[#8A9A1B] ring-3 ring-inset ring-accent dark:ring-dark-accent' : ''}
        ${isLastMove && !isSelected ? 'bg-opacity-80 ring-2 ring-inset ring-[#BACA44] dark:ring-[#9ABA34]' : ''}
        ${isCheck ? 'bg-[#E06C6C] dark:bg-[#C05C5C] animate-pulse' : ''}
        hover:brightness-110
        focus:outline-none
        cursor-pointer
      `}
      onClick={onClick}
    >
      {/* Piece */}
      {piece && (
        <div className={`absolute inset-0 text-6xl flex items-center justify-center select-none drop-shadow-lg ${
          piece.color === 'w' ? 'text-white' : 'text-black dark:text-gray-900'
        }`}>
          {getPieceUnicode(piece)}
        </div>
      )}
      
      {/* Legal move indicator - empty square */}
      {isLegalMove && !piece && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="w-5 h-5 bg-[#646F40] dark:bg-[#94AF70] opacity-70 border-2 border-accent dark:border-dark-accent" />
        </div>
      )}
      
      {/* Legal move indicator - capture */}
      {isLegalMove && piece && (
        <div className="absolute inset-1 pointer-events-none">
          <div className="w-full h-full border-4 border-[#646F40] dark:border-[#94AF70] opacity-70" />
        </div>
      )}
    </button>
  );
};

export default Square;
